import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { combineLatest, Subscription } from "rxjs";
import { DashboardService } from "src/app/services/dashboard.service";
import { NavigationService } from "src/app/services/navigation.service";
import { SessionService } from "src/app/services/session.service";

@Component({
    selector: "app-direct",
    templateUrl: "./direct.component.html",
    styleUrls: ["./direct.component.scss"],
    standalone: false
})
export class DirectComponent implements OnInit, OnDestroy {
  clientLogo: any;
  newColor: any;
  moduleName: any;
  clientKey: any;
  moduleKey: any;
  workName: string = "";
  componentName: any;
  private reqSubcription: Subscription[] = [];

  constructor(
    private sessionService: SessionService,
    private router: ActivatedRoute,
    private dashboardService: DashboardService,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef
  ) {
    this.reqSubcription.push(
      combineLatest([this.router.params, this.router.queryParams]).subscribe(
        ([p, params]: [any, any]) => {
          this.moduleName = p["module"] || "";
          this.componentName = p["component"] || "";
          this.workName = "AI";

          let decryptedParams = this.navigationService.decryptData(params);
          this.clientKey = decryptedParams["cl_key"];
          this.moduleKey = decryptedParams["md_key"];
          this.dashboardService.moduleKey = this.moduleKey;
        }
      )
    );
  }

  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();
  }
  previousPage() {
    this.navigationService.goBack();
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((sub) => sub.unsubscribe());
  }
}
